import { Box, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import { listofRoles } from "../../slices/UserRole/UserRoleSlice";
import { ThemeContext } from "../../theme/ThemeContext";

export default function UserRole(props) {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { darkMode } = useContext(ThemeContext);
  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 10,
  });

  const [filter, setFilter] = React.useState({
    name: "",
    roleScope: "APPLICATION",
  });

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(listofRoles(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4076" && data.data) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.roles);
          setPageSize(data.data.pageSize);
        }
      });
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleTextOverflow = (text) => {
    if (text && text.length > 250) {
      return text.substring(0, 250) + "...";
    } else {
      return text;
    }
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    {
      field: "name",
      headerName: t("ROLE"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.roleName,
    },
    {
      field: "roleCount",
      headerName: t("Person Count"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.employeeRoleCount,
    },
    {
      field: "description",
      headerName: t("ATYPE009"),
      flex: 1,
      minWidth: 1500,
      valueGetter: (params) => params.row.description,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.description}`} placement="bottom-start">
          <span>{params.row.description}</span>
        </Tooltip>
      ),
    },
  ]);

  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h3"
            style={{
              marginLeft: "5px",
              marginRight: "2px",
              color: darkMode ? "#fff" : "#3D4977",
              marginTop: "4px",
            }}
          >
            {t("USERROLE")}
          </Typography>
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", paddingTop: "20px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </>
  );
}
